(function () {
    'use strict';

    //  functions for rule engine
    window.isObject = function (val) {
        return angular.isObject(val);
    };

    window.isDate = function (val) {
        return angular.isDate(val);
    };

    window.isNumber = function (val) {
        return angular.isNumber(val);
    };

    window.isDefined = function (val) {
        return angular.isDefined(val)
    };

    window.isUndefined = function (val) {
        return angular.isUndefined(val)
    };

    window.isString = function (val) {
        return angular.isString(val)
    };

    window.isUndefinedOrEmptyOrNull = function (m) {
        if (isObject(m) && m.hasOwnProperty('ui')) {
            var result;
            try {
                result = eval('m.dataModel.' + m.ui.field);
            }
            catch (e) { }
            return result === '' || result === undefined || result === null;
        }
        return m === '' || m === undefined || m === null;
    };

    window.isEmptyOrNull = function (m) {
        if (isObject(m) && m.hasOwnProperty('ui')) {
            var result;
            try {
                result = eval('m.dataModel.' + m.ui.field);
            }
            catch (e) { }
            return result === '' || result === null;
        }
        return m === '' || m === null;
    };

    window.isUndefinedOrNull = function (m) {
        if (isObject(m) && m.hasOwnProperty('ui')) {
            var result;
            try {
                result = eval('m.dataModel.' + m.ui.field);
            }
            catch (e) { }
            return result === undefined || result === null;
        }
        return m === undefined || m === null;
    };

    angular.module('SMART2').service('RuleEngine', ['$translate', function ($translate) {
        var service = this;
        this.utils = {};

        this.setRules = function (dataConfig, dataModel, cumulativeRules, rules, ruleType) {
            this.dataConfig = dataConfig;
            this.dataModel = dataModel;
            this.cumulativeRules = cumulativeRules;                 //  Cumulative rules
            this.rules = rules;                                     //  Rules object
            this.type = angular.isDefined(ruleType) ? ruleType : 'header';
            this.isNoolsEnabled = !angular.isObject(rules);
        };

        this.setDocumentRules = function (rules) {
            this.documentRules = rules;
        };

        this.setUtils = function (utils) {
            this.utils = utils;
        };

        //Added inorder to translate the errorString which is being appended to the grid rules
        function appendErrorString(result) {
            var resultantString = '';
            if (result && result.params && _.isArray(result.params)) {
                _.each(result.params, function (data, index) {
                    if (data && data.isToBeTranslated) {
                        resultantString += $translate.instant(data.text);
                    } else {
                        resultantString += data.text;
                    }
                });

                result.error = resultantString;
                delete result['params'];
            }
            return result;
        }

        this.executeNools = function (callback, scope) {
            var failedRules = [];
            var headerOrGridConfig = this.dataConfig;
            var dataModel = this.dataModel;
            var ruleType = this.type;
            var rulesObj = this.rules;
            var isNoolsEnabled = this.isNoolsEnabled;
            var tmpRules, tmpRule, tmpRuleResult;

            var invalidArray = [], disableArray = [], totalErrosArray = [];

            if (ruleType == 'grid') {
                _.each(dataModel, function (model, rowIndex) {
                    var virtualDatamodel = angular.copy(model);

                    _.each(angular.isArray(headerOrGridConfig) ? headerOrGridConfig[0].cloumnDefs : headerOrGridConfig.cloumnDefs, function (column, columnIndex) {
                        if (column.hasOwnProperty('rules') && column.rules.length > 0) {
                            angular.extend(column, {
                                fieldName: column.field,
                                errorFieldDisplayName: $translate.instant(column.displayName)
                            });

                            if (column.attributes.type == 'date') {
                                changeDateFormatForNools(column, virtualDatamodel, 'grid');
                            }

                            //  Javascript implementation
                            if (!isNoolsEnabled) {
                                var messageModel = {
                                    ui: angular.extend(column, {
                                        data: column.field,
                                        errorFieldDisplayName: $translate.instant(column.displayName)
                                    }),
                                    dataModel: virtualDatamodel,
                                    index: {
                                        row: rowIndex,
                                        column: columnIndex
                                    },
                                    scope: ''
                                };

                                tmpRules = rulesObj.get(messageModel);

                                for (var i = 0; i < column.rules.length; i++) {
                                    tmpRule = tmpRules[column.rules[i]];
                                    if (angular.isDefined(tmpRule) && angular.isFunction(tmpRule.condition) && tmpRule.condition()) {
                                        //  If rule fails

                                        tmpRuleResult = appendErrorString(tmpRule.result());
                                        if (angular.isDefined(tmpRuleResult.rowColIndex)) {
                                            if (tmpRuleResult.state == 'invalid') {
                                                invalidArray.push(tmpRuleResult.rowColIndex)
                                                totalErrosArray.push(tmpRuleResult);
                                            }
                                            else if (tmpRuleResult.state == 'disable') {
                                                disableArray.push(tmpRuleResult.rowColIndex);
                                            }
                                        }
                                        else {
                                            if (tmpRuleResult.state == 'invalid') {
                                                failedRules.push(tmpRuleResult);
                                            }
                                        }
                                        break;
                                    };
                                }
                            }
                            else {
                                //  Nools implementation
                                var messageModel = [new Message({
                                    ui: angular.extend(column, {
                                        data: column.field
                                    }),
                                    dataModel: virtualDatamodel,
                                    scope: ''
                                })];
                                var rules = messageModel[0].ui.rules;
                                var session = flow.getSession.apply(flow, messageModel);
                                for (var i = 0; i < rules.length; i++) {
                                    session.focus("" + rules[i] + "");
                                }
                                session.on("error", function (data) {
                                    if (data.errors[0].rowColIndex !== undefined) {
                                        if (data.errors[0].state == 'invalid') {
                                            invalidArray.push(data.errors[0].rowColIndex)
                                            totalErrosArray.push(data.errors[0]);
                                            session.dispose();
                                        }
                                        else if (data.errors[0].state == 'disable') {
                                            disableArray.push(data.errors[0].rowColIndex);
                                        }
                                    }
                                    else {
                                        if (data.errors[0].state == 'invalid') {
                                            failedRules.push(data.errors[0]);
                                            session.dispose();
                                        }
                                    }
                                });
                                session.match();
                            }
                        }
                    });
                });

                if (invalidArray.length > 0 || disableArray.length > 0 || totalErrosArray.length > 0) {
                    failedRules.push(invalidArray);
                    failedRules.push(disableArray);
                    failedRules.push(totalErrosArray);
                }
            }
            else if (ruleType == 'cell' && headerOrGridConfig.colDef.hasOwnProperty('rules') && headerOrGridConfig.colDef.rules.length > 0) {
                headerOrGridConfig.colDef.fieldName = headerOrGridConfig.colDef.field;
                var virtualDatamodel = angular.copy(dataModel.entity);

                if (headerOrGridConfig.colDef.attributes.type == 'date') {
                    //scope consists total column defs of line tab.
                    changeDateFormatForNools(scope, virtualDatamodel, 'cell');
                }

                //  Javascript implementation
                if (!isNoolsEnabled) {
                    var messageModel = {
                        ui: angular.extend(headerOrGridConfig.colDef, {
                            errorFieldDisplayName: $translate.instant(headerOrGridConfig.colDef.displayKey)
                        }),
                        dataModel: virtualDatamodel,
                        scope: ''
                    };

                    tmpRules = rulesObj.get(messageModel);

                    for (var i = 0; i < headerOrGridConfig.colDef.rules.length; i++) {
                        tmpRule = tmpRules[headerOrGridConfig.colDef.rules[i]];
                        if (angular.isDefined(tmpRule) && angular.isFunction(tmpRule.condition) && tmpRule.condition()) {
                            //  If rule fails
                            failedRules.push(appendErrorString(tmpRule.result()));
                            break;
                        };
                    }
                }
                else {
                    var messageModel = [new Message({
                        ui: headerOrGridConfig.colDef,
                        dataModel: virtualDatamodel,
                        scope: ''
                    })];
                    var session = flow.getSession.apply(flow, messageModel);
                    var rules = headerOrGridConfig.colDef.rules;
                    for (var i = 0; i < rules.length; i++) {
                        session.focus("" + rules[i] + "");
                    }
                    session.on("error", function (data) {
                        failedRules.push(data.errors[0]);
                        session.dispose();
                    });
                    session.match();
                }
            }
            else if (ruleType == 'chargeGrid') {
                dataModel = dataModel.orderData.ItemChargesForHeader;
                _.each(dataModel, function (model) {
                    var virtualDatamodel = angular.copy(model);
                    var columnArr = [];
                    _.each(headerOrGridConfig[0].cloumnDefs, function (column) {
                        angular.extend(column, {
                            fieldName: column.field
                        });
                        if (column.hasOwnProperty('rules')) {
                            if (column.attributes.type == 'date') {
                                changeDateFormatForNools(column, virtualDatamodel);
                            }
                            var messageModel = [new Message({
                                ui: angular.extend(column, {
                                    data: column.field
                                }),
                                dataModel: virtualDatamodel,
                                scope: ''
                            })];
                            columnArr.push(messageModel);
                        }
                    });
                    _.each(columnArr, function (col) {
                        var rules = col[0].ui.rules;
                        var session = flow.getSession.apply(flow, col);
                        for (var i = 0; i < rules.length; i++) {
                            session.focus("" + rules[i] + "");
                        }
                        session.on("error", function (data) {
                            if (data.errors[0].state == 'invalid') {
                                failedRules.push(data.errors[0]);
                                session.dispose();
                            }
                        });
                        session.match();
                    });
                });
            }

            if (angular.isFunction(callback)) {
                callback({
                    success: failedRules.length == 0,
                    failedRules: failedRules
                });
            }
            else {
                return {
                    success: failedRules.length == 0,
                    failedRules: failedRules
                };
            }
        };

        this.isValid = function (rule, callback) {
            if (typeof Header == "undefined") {
                var tmpRules = this.documentRules.get({
                    ui: '',
                    dataModel: this.dataModel,
                    scope: '',
                    utils: this.utils
                });

                var tmpRule = tmpRules[rule];

                if (angular.isDefined(tmpRule) && angular.isFunction(tmpRule.condition) && tmpRule.condition()) {
                    angular.isFunction(callback) && callback({
                        success: false,
                        errorData: appendErrorString(tmpRule.result())
                    });
                }
            }
            else {
                var messageModel = [new Header({
                    ui: '',
                    dataModel: this.dataModel,
                    scope: '',
                    utils: this.utils
                })];
                var session = headerFlow.getSession.apply(headerFlow, messageModel).focus(rule);
                session.on("error", function (data) {
                    angular.isFunction(callback) && callback({
                        success: false,
                        errorData: data.errors[0]
                    });
                    session.dispose();
                });
                session.match();
            }
        };

        this.execute = function (callback, currentScope) {
            if (angular.isDefined(this.type) && this.type != 'header') {
                this.executeNools(callback, currentScope);
                return;
            }

            //  Inline validations
            var isValid = true;
            var tmpPropertyValue;
            var failedRules = [];
            var rulesObj = this.rules;
            var isNoolsEnabled = this.isNoolsEnabled;
            var tmpRules, tmpRule, tmpRuleResult;


            /*
             * Inline validation
             */
            for (var i = 0; i < this.dataConfig.length; i++) {
                if (this.dataConfig[i].isHidden) {
                    continue;
                }
                for (var j = 0; j < this.dataConfig[i].rows.length; j++) {
                    for (var k = 0; k < this.dataConfig[i].rows[j].properties.length; k++) {
                        if (this.dataConfig[i].rows[j].properties[k].isHidden) {
                            continue;
                        }

                        //skip rules, when readonly
                        if (Object(this.dataConfig[i].rows[j].properties[k]).hasOwnProperty('attributes')) {
                            if (this.dataConfig[i].rows[j].properties[k].attributes.readonly) {
                                continue;
                            }
                        }

                        tmpPropertyValue = undefined;

                        if (this.dataConfig[i].rows[j].properties[k].attributes && this.dataConfig[i].rows[j].properties[k].attributes.hasOwnProperty('ngModelOptions') && this.dataConfig[i].rows[j].properties[k].attributes.ngModelOptions.getterSetter) {
                            tmpPropertyValue = eval('currentScope.' + this.dataConfig[i].rows[j].properties[k].data + '()');
                        }
                        else {
                            try {
                                if(this.dataConfig[i].rows[j].properties[k].attributes.type == 'date' && this.dataConfig[i].rows[j].properties[k].type != 'subsection'){
                                    tmpPropertyValue = eval('this.dataModel.' + this.dataConfig[i].rows[j].properties[k].data);
                                }
                                else if (typeof eval('this.dataModel.' + this.dataConfig[i].rows[j].properties[k].data) == 'object' && this.dataConfig[i].rows[j].properties[k].type != 'subsection') {
                                    if (this.dataConfig[i].rows[j].properties[k].attributes != undefined)
                                        var datakey = this.dataConfig[i].rows[j].properties[k].attributes.displayformat != undefined ? this.dataConfig[i].rows[j].properties[k].attributes.displayformat : this.dataConfig[i].rows[j].properties[k].attributes.datakey;
                                    else if (this.dataConfig[i].rows[j].properties[k].ui != undefined)
                                        var datakey = this.dataConfig[i].rows[j].properties[k].ui.displayformat ? this.dataConfig[i].rows[j].properties[k].ui.displayformat : this.dataConfig[i].rows[j].properties[k].ui.datakey;

                                    datakey = datakey.split('-');
                                    tmpPropertyValue = '';
                                    for (var m = 0; m < datakey.length; m++) {
                                        if (datakey[m].indexOf('{') > -1)
                                            datakey[m] = datakey[m].replace("{", '').replace("}", '');

                                        tmpPropertyValue += eval('this.dataModel.' + this.dataConfig[i].rows[j].properties[k].data + '.' + datakey[m]).trim();
                                    }
                                }
                                else
                                    tmpPropertyValue = eval('this.dataModel.' + this.dataConfig[i].rows[j].properties[k].data);
                            }
                            catch (e) { }
                        }

                        /*
                         * Mandatory rule
                         */
                        var isValidated = false;
                        if (Object(this.dataConfig[i].rows[j].properties[k]).hasOwnProperty('attributes')) {
                            if (Object(this.dataConfig[i].rows[j].properties[k].attributes).hasOwnProperty('type') && this.dataConfig[i].rows[j].properties[k].attributes.type == 'number') {
                                isValidated = true;
                                if ((this.dataConfig[i].rows[j].properties[k].isMandatory && (tmpPropertyValue == undefined || tmpPropertyValue === "" || tmpPropertyValue == null || isNaN(tmpPropertyValue))) || (!this.dataConfig[i].rows[j].properties[k].isMandatory && isNaN(tmpPropertyValue) && tmpPropertyValue != undefined)) {
                                    failedRules.push({
                                        type: 'required',
                                        section:this.dataConfig[i],
                                        uiConfig: this.dataConfig[i].rows[j].properties[k],
                                        rule: "isNaN(this)",
                                        error: $translate.instant('PLATFORM_ThisFieldShouldBeNumber')
                                    });
                                }
                            }

                            else if (Object(this.dataConfig[i].rows[j].properties[k].attributes).hasOwnProperty('type') && this.dataConfig[i].rows[j].properties[k].attributes.type == 'date') {
                                isValidated = true;
                                if ((this.dataConfig[i].rows[j].properties[k].isMandatory && (tmpPropertyValue == undefined || tmpPropertyValue === "" || tmpPropertyValue == null )) ) {
                                    failedRules.push({
                                        type: 'required',
                                        section:this.dataConfig[i],
                                        uiConfig: this.dataConfig[i].rows[j].properties[k],
                                        rule: "this == ''",
                                        error: $translate.instant('PLATFORM_ThisFieldShouldNotBeBlank')
                                    });
                                }
                            }

                            else if (Object(this.dataConfig[i].rows[j].properties[k].attributes).hasOwnProperty('type') && this.dataConfig[i].rows[j].properties[k].attributes.type == 'autocomplete') {
                                isValidated = true;
                                if (this.dataConfig[i].rows[j].properties[k].isMandatory && (tmpPropertyValue + '' == '' || tmpPropertyValue == null || tmpPropertyValue == undefined)) {
                                    failedRules.push({
                                        type: 'required',
                                        section: this.dataConfig[i],
                                        uiConfig: this.dataConfig[i].rows[j].properties[k],
                                        rule: "this == ''",
                                        error: $translate.instant('PLATFORM_ThisFieldShouldNotBeBlank')
                                    });
                                }
                            }
                        }

                        if (!isValidated && this.dataConfig[i].rows[j].properties[k].type != 'subsection' && this.dataConfig[i].rows[j].properties[k].type != 'checkbox' && this.dataConfig[i].rows[j].properties[k].type != 'switch' && this.dataConfig[i].rows[j].properties[k].isMandatory && (tmpPropertyValue == '' || tmpPropertyValue == undefined || tmpPropertyValue == null)) {
                            failedRules.push({
                                type: 'required',
                                section: this.dataConfig[i],
                                uiConfig: this.dataConfig[i].rows[j].properties[k],
                                rule: "this == ''",
                                error: $translate.instant('PLATFORM_ThisFieldShouldNotBeBlank')
                            });
                        }

                        /*
                         * Inline rules
                         */
                        if (Object(this.dataConfig[i].rows[j].properties[k]).hasOwnProperty('rules')) {
                            if (this.dataConfig[i].rows[j].properties[k].rules) {
                                for (var l = 0; l < this.dataConfig[i].rows[j].properties[k].rules.length; l++) {
                                    if (typeof this.dataConfig[i].rows[j].properties[k].rules[l] != 'string') {
                                        if (eval((this.dataConfig[i].rows[j].properties[k].rules[l].rule).replace(/this/g, 'tmpPropertyValue'))) {
                                            failedRules.push({
                                                type: 'inline',
                                                section: this.dataConfig[i],
                                                uiConfig: this.dataConfig[i].rows[j].properties[k],
                                                rule: this.dataConfig[i].rows[j].properties[k].rules[l].rule,
                                                error: this.dataConfig[i].rows[j].properties[k].rules[l].error
                                            });
                                        }
                                    }
                                    else if (isNoolsEnabled) {
                                        var messageModel = [new Header({
                                            ui: this.dataConfig[i].rows[j].properties[k],
                                            dataModel: this.dataModel,
                                            scope: currentScope,
                                            utils: this.utils
                                        })];

                                        var session = headerFlow.getSession.apply(headerFlow, messageModel).focus(this.dataConfig[i].rows[j].properties[k].rules[l]);
                                        var _section=this.dataConfig[i];
                                        var _uiElement = _section.rows[j].properties[k];
                                        session.on("error", function (data) {
                                            data.errors[0].uiConfig = _uiElement;
                                            data.errors[0].section = _section;
                                            failedRules.push(data.errors[0]);
                                            session.dispose();
                                        });

                                        session.match();
                                    }
                                    else {
                                        var messageModel = {
                                            ui: {
                                                section: this.dataConfig[i],
                                                property: this.dataConfig[i].rows[j].properties[k],
                                            },
                                            dataModel: this.dataModel,
                                            scope: currentScope,
                                            utils: this.utils
                                        };

                                        tmpRules = rulesObj.get(messageModel);
                                        tmpRule = tmpRules[this.dataConfig[i].rows[j].properties[k].rules[l]];

                                        if (angular.isDefined(tmpRule) && angular.isFunction(tmpRule.condition) && tmpRule.condition()) {
                                            //  If rule fails
                                            this.dataConfig[i].rows[j].properties[k].validate = true;
                                            failedRules.push(appendErrorString(tmpRule.result()));
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            /*
             *  Cumulative validations  
             */
            if (angular.isDefined(this.cumulativeRules) && angular.isArray(this.cumulativeRules) && this.cumulativeRules.length > 0) {
                tmpRules = angular.isDefined(this.rules) && angular.isFunction(this.rules.get) && this.rules.get({
                    ui: {},
                    dataModel: this.dataModel,
                    scope: currentScope,
                    utils: this.utils
                });

                for (var i = 0; i < this.cumulativeRules.length; i++) {
                    if (typeof this.cumulativeRules[i] != 'string' && eval((this.cumulativeRules[i].rule).replace(/this/g, 'this.dataModel'))) {
                        failedRules.push({
                            type: 'cumulative',
                            rule: this.cumulativeRules[i].rule,
                            error: this.cumulativeRules[i].error
                        });
                    }
                    else if (isNoolsEnabled) {
                        var messageModel = [new Header({
                            ui: {},
                            dataModel: this.dataModel,
                            scope: currentScope,
                            utils: this.utils
                        })];

                        var session = headerFlow.getSession.apply(headerFlow, messageModel).focus(this.cumulativeRules[i]);

                        session.on("error", function (data) {
                            failedRules.push(data.errors[0]);
                            session.dispose();
                        });

                        session.match();
                    }
                    else {
                        tmpRule = tmpRules[this.cumulativeRules[i]];

                        if (angular.isDefined(tmpRule) && angular.isFunction(tmpRule.condition) && tmpRule.condition()) {
                            //  If rule fails
                            failedRules.push(appendErrorString(tmpRule.result()));
                            break;
                        }
                    }
                }
            }

            if (failedRules.length > 0 && failedRules[0].section) {
                failedRules[0].section.isContentLoaded = true;
                failedRules[0].section.isActive = true;
            }

            angular.forEach(failedRules, function (value, key) {
                if (value.uiConfig) {
                    value.uiConfig.validate = true;
                }
            });

            if (failedRules.length > 0 && ((failedRules[0].hasOwnProperty('uiConfig') && failedRules[0].uiConfig != undefined) || (failedRules[0].hasOwnProperty('property') && failedRules[0].property != '' && failedRules[0].property != undefined))) {
                typeof failedRules[0].uiConfig != 'undefined' ? failedRules[0].uiConfig.focus = true : failedRules[0].property.focus = true;
            }

            tmpRules = null;
            tmpRule = null;
            tmpRuleResult = null;

            angular.isFunction(callback) && callback({
                success: failedRules.length == 0,
                failedRules: failedRules
            });
        };


        this.executeOnStaticForm = function (callback) {
            var isValid = true;
            var failedRules = [];

            for (var key in this.dataConfig) {
                for (var i = 0; i < this.dataConfig[key].rules.length; i++) {
                    if (eval(this.dataConfig[key].rules[i].rule.replace(/this/g, 'this.dataModel.' + key))) {
                        failedRules.push({
                            type: 'inline',
                            rule: this.dataConfig[key].rules[i].rule,
                            error: this.dataConfig[key].rules[i].error
                        });
                        this.dataConfig[key].validate = true;
                        if (failedRules.length == 1) {
                            this.dataConfig[key].focus = true;
                        }
                        isValid = false;
                    }
                }
            }

            /*
             *  Cumulative validations  
             */
            if (this.cumulativeRules) {
                for (var i = 0; i < this.cumulativeRules.length; i++) {
                    if (eval((this.cumulativeRules[i].rule).replace(/this/g, 'this.dataModel'))) {
                        failedRules.push({
                            type: 'cumulative',
                            rule: this.cumulativeRules[i].rule,
                            error: this.cumulativeRules[i].error
                        });
                        isValid = false;
                    }
                }
            }

            if (angular.isFunction(callback)) {
                callback({
                    success: isValid,
                    data: failedRules
                });
            }
        };


        function changeDateFormatForNools(colDefs, virtualDatamodel, type) {
            if (colDefs != '' && type == 'cell') {
                _.each(colDefs.cloumnDefs, function (colDef) {
                    if (colDef.attributes.type == 'date') {
                        var field = colDef.field;
                        var fieldVal = field.split('.');
                        if (fieldVal.length > 1) {
                            var fieldzeroval = eval('virtualDatamodel.' + fieldVal[0]);
                            if (fieldzeroval !== undefined && fieldzeroval !== null) {
                                var dateVar = eval('virtualDatamodel.' + fieldVal[1]);
                                if (dateVar != undefined & dateVar != '')
                                    virtualDatamodel[field] = convertDate(dateVar);
                                else
                                    virtualDatamodel[field] = "";
                            }
                        }
                        else {
                            var dateVar = eval('virtualDatamodel.' + fieldVal[0]);
                            if (dateVar != undefined & dateVar != '')
                                virtualDatamodel[field] = convertDate(dateVar);
                            else
                                virtualDatamodel[field] = "";
                        }
                    }
                });
            }
            else if (colDefs != '' && type == 'grid') {
                var field = colDefs.field;
                var fieldVal = field.split('.');
                if (fieldVal.length > 1) {
                    var fieldzeroval = eval('virtualDatamodel.' + fieldVal[0]);
                    if (fieldzeroval !== undefined && fieldzeroval !== null) {
                        var dateVar = eval('virtualDatamodel.' + fieldVal[1]);
                        if (dateVar != undefined & dateVar != '')
                            virtualDatamodel[field] = convertDate(dateVar);
                        else
                            virtualDatamodel[field] = "";
                    }
                }
                else {
                    var dateVar = eval('virtualDatamodel.' + fieldVal[0]);
                    if (dateVar != undefined & dateVar != '')
                        virtualDatamodel[field] = convertDate(dateVar);
                    else
                        virtualDatamodel[field] = "";
                }
            }
        };


        function convertDate(dateVar) {
            if (typeof dateVar != 'undefined' && dateVar != null && isNaN(dateVar) && dateVar.indexOf('/Date(') > -1) {
                var res = dateVar.replace("/Date(", "");
                var datestring = res.replace(")/", "");
                var newdate = new Date(parseInt(datestring));
                return new Date(newdate.getFullYear(), newdate.getMonth(), newdate.getDate() + 1);
            }
            else if (typeof dateVar != 'undefined' && dateVar != null && !isNaN(dateVar) && angular.isFunction(dateVar.getFullYear)) {
                
                    var newdate = new Date(dateVar);
                    return new Date(newdate.getFullYear(), newdate.getMonth(), newdate.getDate() + 1);                
            }
            else if (typeof dateVar != 'undefined' && dateVar != null && !isNaN(dateVar)) {
                var newdate = new Date(parseInt(dateVar));
                return new Date(newdate.getFullYear(), newdate.getMonth(), newdate.getDate() + 1);
            }
        };
    }]);
})();